import { ExceptionsTracker } from '@aurelia-toolkit/alert';
import { diag } from '@opentelemetry/api';

export class OpenTelemetryExceptionsTracker extends ExceptionsTracker {
  override track(error: Error) {
    diag.error(error.message, error);
  }
}
